


















import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'

export default Vue.extend({
  name: 'ItemsListingLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    isKanban: {
      type: Boolean,
      default: false,
    },
  },
})
